import React from 'react';

// 骨架屏基础组件
export const Skeleton = ({ className = '', style = {} }) => (
  <div className={`skeleton ${className}`} style={style} />
);

// 任务卡片骨架屏
export const TaskCardSkeleton = () => (
  <div className="skeleton-task-card">
    <div className="skeleton-task-header">
      <Skeleton className="skeleton-id" style={{ width: '80px', height: '20px' }} />
      <Skeleton className="skeleton-tag" style={{ width: '60px', height: '24px', borderRadius: '12px' }} />
    </div>
    <div className="skeleton-task-body">
      <div className="skeleton-row">
        <Skeleton style={{ width: '40px', height: '16px' }} />
        <Skeleton style={{ width: '120px', height: '16px' }} />
      </div>
      <div className="skeleton-row">
        <Skeleton style={{ width: '60px', height: '16px' }} />
        <Skeleton style={{ width: '100px', height: '16px' }} />
      </div>
      <div className="skeleton-row">
        <Skeleton style={{ width: '50px', height: '16px' }} />
        <Skeleton style={{ width: '80px', height: '16px' }} />
      </div>
    </div>
    <div className="skeleton-task-actions">
      <Skeleton style={{ width: '80px', height: '36px', borderRadius: '8px' }} />
      <Skeleton style={{ width: '80px', height: '36px', borderRadius: '8px' }} />
      <Skeleton style={{ width: '80px', height: '36px', borderRadius: '8px' }} />
    </div>
  </div>
);

// 周视图骨架屏
export const WeekViewSkeleton = () => (
  <div className="skeleton-week-view">
    <div className="skeleton-week-header">
      <Skeleton style={{ width: '200px', height: '24px' }} />
    </div>
    <div className="skeleton-week-grid">
      {Array.from({ length: 7 }).map((_, i) => (
        <div key={i} className="skeleton-week-day">
          <Skeleton style={{ width: '100%', height: '40px', marginBottom: '8px' }} />
          <Skeleton style={{ width: '100%', height: '60px' }} />
        </div>
      ))}
    </div>
  </div>
);

// 表格骨架屏
export const TableSkeleton = ({ rows = 5 }) => (
  <div className="skeleton-table">
    <div className="skeleton-table-header">
      {Array.from({ length: 6 }).map((_, i) => (
        <Skeleton key={i} style={{ width: '120px', height: '20px' }} />
      ))}
    </div>
    {Array.from({ length: rows }).map((_, i) => (
      <div key={i} className="skeleton-table-row">
        {Array.from({ length: 6 }).map((_, j) => (
          <Skeleton key={j} style={{ width: '120px', height: '16px' }} />
        ))}
      </div>
    ))}
  </div>
);

// 统计卡片骨架屏
export const StatCardSkeleton = () => (
  <div className="skeleton-stat-card">
    <Skeleton style={{ width: '80px', height: '14px', marginBottom: '12px' }} />
    <Skeleton style={{ width: '60px', height: '32px' }} />
  </div>
);
